
export const LOG_TYPE_STATS = 0
export const LOG_TYPE_FINISH_MODAL = 1
export const LOG_TYPE_PAYMENT_MODAL = 2
